<template>
  <div>
    <van-row class="row-box margin-top-box">
      <p>
        聚亲修族谱，族谱更聚亲！
      </p>
      <p>
        聚亲成族谱，族谱能聚亲！
      </p>
    </van-row>
    <van-row class="row-box-h1 margin-top-box">
      <p>
        大塘符石公后裔
      </p>
      <p>
        入谱资料收集
      </p>
    </van-row>
<!--    <div class="login">-->
<!--      <van-form @submit="onSubmit" >-->
<!--        <van-field-->
<!--            style="border-top-left-radius: 5px;border-top-right-radius: 5px;border-style:solid;border-width:1px;border-color: #0076ff;border-bottom: none"-->
<!--            v-model="username"-->
<!--            type="tel"-->
<!--            name="手机号码"-->
<!--            label="手机号码"-->
<!--            left-icon="friends-o"-->
<!--            placeholder="手机号码（非必填）"-->
<!--        />-->
<!--        <van-field-->
<!--            style="border-bottom-left-radius: 5px;border-bottom-right-radius: 5px;border-style:solid;border-width:1px;border-color: #0076ff;border-top-color:white;border-top: none"-->
<!--            v-model="password"-->
<!--            type="password"-->
<!--            name="密码"-->
<!--            label="密码"-->
<!--            placeholder="密码"-->
<!--            left-icon="smile-o"-->
<!--            :rules="[{ required: true, message: '请填写密码' }]"-->
<!--        />-->
<!--        <div style="margin: 16px;margin-top: 50px">-->
<!--          <van-button round block type="info" native-type="submit">登入</van-button>-->
<!--        </div>-->
<!--      </van-form>-->
<!--    </div>-->
    <div style="margin-left: 25%">
      <div  class="qrcode" ref="qrCodeUrl"></div>
      <div style="margin-left: 3%;font-size: 20px;font-weight: bold;color: #7B1002">
        扫码进入小程序添加
      </div>
    </div>

    <van-row class="row-box-white margin-top-box">
      <p>
        填写规则：
      </p>
      <p>
        1、名字必须准确！必填资料必须准确，选填越详细，族谱就越准确越好！
      </p>
      <p>
        2、每个人都要有详细资料，一人一份，每人都必须填写自己到祖父
      </p>
      <p>
        3、每个人需要填写上下2代和片区名称，是为了区别同名以及做世系……
      </p>
      <p>
        4、建议每户熟悉手机操作的人统一填写。
      </p>
      <p>
        5、每户录入，建议一人录入，另一人校对。
      </p>
      <p>
        6、每户至少填写到永字辈、最好到道字辈，即使去世的永字辈和以下也要填写。
      </p>
      <p>
        7、上次修谱时间久了，请尽量填写更多长辈资料
      </p>
      <p>
        8、本二维码为符石公后裔专用，不要分亨码给外姓人，免得有假资料
      </p>
      <p>
        9、招募志愿者，注册成为录入员，代其他人录入资料。
      </p>
      <p>
        10、招募志愿者，注册成为校对员，一个片区至少一个人。
      </p>
    </van-row>
  </div>
</template>

<script>
  import { getTokenPedigree,setTokenPedigree } from '@/utils/authority'
  import QRCode from 'qrcodejs2'
  export default {
    name: "login",
    data() {
      return {
        username: '',
        password: '',
      };
    },
    mounted() {
      // if(getTokenPedigree()){
      //   this.$router.push({
      //     path:'/pedigree/form'
      //   })
      // }
      this.creatQrCode();
    },
    methods: {
      onSubmit(values) {
        //校验密码
        if("8888" !== this.password){
          this.$notify({ type: 'danger', message:  '密码错误',duration: 1000 });
          return
        }
        setTokenPedigree(this.$lodash.generateUUID())
        this.$router.push({
          path:'/pedigree/form'
        })
      },
      creatQrCode() {
        const data = this.getCache();
        let ids = []
        if(data){
          ids = data.ids
        }
        var qrcode = new QRCode(this.$refs.qrCodeUrl, {
          text: 'https://client.kinfriend.com/qrcode/a/pedigree.html?teamId=73&id=' + ids.join('@'), // 需要转换为二维码的内容
          width: 200,
          height: 200,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        })
      },
      getCache(){
        const str = localStorage.getItem("P_PEOPLE")
        return JSON.parse(str)
      },
    },
  }
</script>

<style scoped>
  body{
    background-image: url("https://file.kinfriend.com/app/zupu-bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100vh;
    /*position: relative;*/
  }
  .row-box{
    text-align: center;
    color: rgb(170,30,36);
    font-size: 46px;
    font-weight: bold;

  }
  .row-box-white{
    text-align: left;
    color: black;
    font-size: 32px;
    font-weight: bold;
    margin: 30px;
    border-radius: 30px;
    /*background-color: white;*/
    text-indent: 20px;
  }
  .row-box-white p{
    margin-bottom: 20px;
  }
  .row-box-h1{
    text-align: center;
    color: rgb(170,30,36);
    font-size: 80px;
    font-weight: bold;

  }
  .margin-top-box{
    padding-top: 40px;
  }
  .login{
    margin: 40px;
    padding-top: 10px;

  }

</style>
